// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__DLdgq","footer":"ModalFilter_footer__39btf"};